import { getLangCode, getLangData, useAppDispatch, useAppSelector } from "@hypexone/uicore";
import { useEffect } from "react";

type StateProps = {
  langSelected: string;
  setLangSelected: any;
}

const LanguagesList:React.FC<StateProps> = (props) => {
  const {langSelected, setLangSelected} = props;
  const { domainConfig } = useAppSelector((state) => state.common);
  const languages = domainConfig.languages
  const dispatch = useAppDispatch();

 
  
  useEffect(() => {
    if(langSelected !== undefined){
      console.log(langSelected,"SR")
        sessionStorage.setItem("lang", langSelected);
        dispatch(getLangData(langSelected));
    }
  }, [langSelected]);

  return (
    <div className="flex flex-col gap-1 py-2">
      {languages.map((language) => (
        <div
          key={language}
          className="text-black text-sm px-2 cursor-pointer hover:underline"
            onClick={() => {
                setLangSelected(getLangCode(language)?.toLowerCase())
                console.log('whnjbee')
            }}
        >
          {language}
        </div>
      ))}
    </div>
  );
};

export default LanguagesList;
